import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'

export const input =
  (textAlign: 'start' | 'end' = 'end') =>
  (theme: Theme) => css`
    padding: 0;
    width: 100%;
    color: ${theme.palette.text.title};
    caret-color: ${theme.palette.primary.mainContrast};
    border: none;
    background-color: transparent;
    /* 16px to prevent ios zooming */
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    text-align: ${textAlign};

    &::placeholder,
    &.empty {
      color: ${theme.palette.tertiary.mediumContrastAlternative};
      font-weight: 400;
    }

    &:disabled {
      opacity: 1; /* required on iOS */
      -webkit-text-fill-color: ${theme.palette.ghost
        .mediumContrast}; /* required on iOS */
      color: ${theme.palette.ghost.mediumContrast};
      cursor: not-allowed;
    }
  `
